import {
  Text,
  GreyGrey80,
  Primary13Regular,
  useNotifications,
  SimpleModal
} from '@sequencehq/core-components'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useMutation } from '@sequencehq/api'

type Props = {
  creditNoteId: string
  isOpen: boolean
  onClose: () => void
  onInvoiceCreated: (createdInvoiceId: string) => void
}

export const RecalculateCreditNoteDialog = ({
  creditNoteId,
  isOpen,
  onClose,
  onInvoiceCreated
}: Props) => {
  const { displayNotification } = useNotifications()

  const recalculateMutation = useMutation(
    dashboardv99990101Client.postRecalculateCreditNote,
    {
      onError: () => {
        displayNotification('Failed to recalculate credit note', {
          type: 'error'
        })
      }
    }
  )

  const handleSubmit = async () => {
    const result = await recalculateMutation.mutateAsync({ id: creditNoteId })

    if (!result) return false

    if ('createdInvoiceId' in result) {
      onInvoiceCreated(result.createdInvoiceId)
      return true
    }

    displayNotification('Credit note recalculated', { type: 'success' })
    return true
  }

  return (
    <SimpleModal
      data-testid="modal.recalculate-credit-note"
      variant="dialog"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Recalculate credit note"
      submitButtonText="Recalculate credit note"
      submittingButtonText="Recalculating..."
    >
      <Text {...Primary13Regular} color={GreyGrey80}>
        Recalculating the credit note will update line items based on the latest
        usage data.
      </Text>
    </SimpleModal>
  )
}
